import { Link, Typography } from "@material-ui/core";
import React from "react";
import CloseOutlined from "@material-ui/icons/CloseOutlined";

function Help() {
    const [adOpacity, setAdOpacity] = React.useState(1.0);
    return (<>
        <Typography variant="body1" gutterBottom style={{ border: "solid 1.6px", padding: "0.1em 0.7em", borderRadius: "2em", opacity: adOpacity, display: "flex" }}>
            광고: 일격필살 코어에 맞춰 스킬을 쓰려면 <Link href="https://mapletimer.cro.sh" target="_blank" rel="noreferrer noopener">일격필살 타이머</Link>를 이용해보세요.
            <CloseOutlined onClick={() => setAdOpacity(0)} style={{ display: "inline-block", verticalAlign: "middle", marginLeft: "auto" }} />
        </Typography>
        <Typography variant="h3" gutterBottom>사이트 이용 방법</Typography>
        <Typography variant="h4" gutterBottom>1. 크롬 확장 프로그램 설치하기</Typography>
        <Typography variant="body1" gutterBottom>
            사이트 상단에 있는 [크롬 확장 프로그램 다운로드]를 클릭하여 크롬에 추가합니다.
            캐릭터 정보를 로드하려면 <u>최신 버전의 크롬 브라우저</u>가 꼭 필요합니다(아이템 검색은 상관없습니다).
        </Typography>
        <Typography variant="h4" gutterBottom>2. 내 캐릭터 정보 창으로 이동</Typography>
        <img src="/images/help1.png" style={{ maxWidth: '70%' }} alt="help-img-1" />
        <Typography variant="body1" gutterBottom>
            크롬을 켠 후 <Link href="https://maplestory.nexon.com/Home/Main" target="_black" rel="noreferrer noopener">메이플스토리 홈페이지</Link>에 로그인한 다음, 내 캐릭터 아이콘을 클릭합니다.
        </Typography>
        <Typography variant="h4" gutterBottom>3. 캐릭터 정보 로드</Typography>
        <img src="/images/help2.png" style={{ maxWidth: '70%' }} alt="help-img-2" />
        <img src="/images/help3.png" style={{ maxWidth: '70%' }} alt="help-img-3" />
        <Typography variant="body1" gutterBottom>
            내 캐릭터 정보 창에서 확장 프로그램을 켠 후 우측 상단의 새로고침 버튼을 클릭합니다. <br />
            무시하려는 캐릭터가 있다면 목록에서 휴지통 버튼을 눌러 제거할 수 있습니다.
        </Typography>
        <img src="/images/help4.png" style={{ maxWidth: '70%' }} alt="help-img-4" />
        <img src="/images/help5.png" style={{ maxWidth: '70%' }} alt="help-img-5" />
        <Typography variant="body1" gutterBottom>
            캐릭터 정보를 로드하는 데는 약 3~4분 가량이 소요됩니다. 이 때 <strong>확장 프로그램 창을 끄면 로드가 취소되니</strong> 창을 끄지 말아주세요. <br />
            캐릭터 정보 로드가 완료되면 우측 상단의 저장 버튼을 클릭하고, 이 사이트로 돌아와 상단의 [아이템 목록 로드] 버튼을 클릭해 로드하면 검색을 이용할 수 있습니다.
        </Typography>
        <Typography variant="h4" gutterBottom>⚠️ 주의</Typography>
        <Typography variant="body1" gutterBottom>
            이 확장 프로그램과 사이트는 넥슨 코리아와 무관합니다. <br />
            이 확장 프로그램은 캐릭터 정보를 넥슨 공식 홈페이지에서 가져옵니다. 매우 많은 캐릭터 정보를 여러 번 로드하려 하면 넥슨 홈페이지에서 IP 차단(대개 30분)을 당할 수 있습니다. (40개 이상의 캐릭터들을 3회 이상 연속으로 로드하지 마세요) <br />
            메소량은 현재 창고 메소만 조회 가능합니다. 이후 버전에서 수정 예정입니다. <br />
            소울이 장착된 무기류는 검색이 제대로 되지 않습니다(소울 이름으로 인식됩니다). 추후 수정하겠습니다. <br />
            가방(채집물, 의자, 소울 등) 안에 있는 아이템은 검색할 수 없습니다. 공식 사이트에서 정보를 제공하지 않기 때문에 알 방법이 없습니다. <br />
            <br />
            버그 및 기타 문의 등은 amazingblaster12321$gmail:com 으로 문의 바랍니다. (:는 .으로, $는 @으로 바꾸세요)
        </Typography>
    </>);
}

export default Help;